import React, { useState } from "react";
import "./Wordmark.css";
import axios from "axios";

const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;

const Wordmark = () => {
    const BASEURL = {
      WORDMARK_STATUS: `${apiEndpoint}/api/wordmark-status`,
    };
  // const BASEURL = {
  //   WORDMARK_STATUS: `http://localhost:8000/api/wordmark-status`,
  // };
  const [searchTerm, setSearchTerm] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(BASEURL.WORDMARK_STATUS, {
        search_term: searchTerm,
      });
      setResult(response.data);
    } catch (err) {
      console.log(err);
      setError(
        err.response ? err.response.data.error : "An unexpected error occurred"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="WordmarkStatus">
      <h2>Wordmark Status Checker</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Enter a word"
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? "Checking..." : "Check Status"}
        </button>
      </form>
      {error && <div className="error">{error}</div>}
      {result && (
        <div className="result">
          <h3>Results:</h3>
          <table className="result-table">
            <thead>
              <tr>
                <th>Wordmark</th>

                <th>Owner</th>
                <th>Status</th>
                {/* <th>Alive</th> */}
                <th>From</th>
              </tr>
            </thead>
            <tbody>
              {result.map((item, index) => (
                <tr key={index}>
                  <td>{item.wordmark}</td>
                  <td>{item.owner}</td>
                  <td>{item.status}</td>
                  <td>{item.from}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Wordmark;
